import { REHYDRATE } from "redux-persist"
import {

    CAREER_INVITE_SUBMIT_BEGIN,
    CAREER_INVITE_SUBMIT_FAIL,
    CAREER_INVITE_SUBMIT_SUCCESS,

} from "../actions/careerActions"

import {ANY_FIELD_UPDATE, updatedObject} from "../actions/formActions";
import {LOGOUT} from "../actions/loginStateActions";

const INITIAL_STATE = {
    status: 'editing'
  }


export default function careerInviteWorkspaceReducer(state = { status: 'editing' }, action) {

    switch(action.type) {
        case REHYDRATE: {
                return state;
        }

        case ANY_FIELD_UPDATE: {
            if (action.storeName !== 'careerInvite')
                return state

            return {...state,
                data: updatedObject(state.data, action.accessPath, action.newVal)
            }
        }

        case CAREER_INVITE_SUBMIT_BEGIN:
            return {...state, status: 'submitting'};

        case CAREER_INVITE_SUBMIT_SUCCESS:
            return INITIAL_STATE;

        case CAREER_INVITE_SUBMIT_FAIL:
            return {...INITIAL_STATE, failReason: action.reason};

        case LOGOUT:
            return {...state, status: 'uninitialized'};

        default:
            return state
    }
}



